import Button from 'components/shared/Button/Button'
import Icon from 'components/shared/Icon/Icon'
import { printUrl } from 'helpers/Project'
import PropTypes from 'prop-types'
import { withNamespaces } from 'react-i18next'

export const PrintButton = ({
  t,
  locale,
  slug,
  isPrintPressed,
  setIsPrintPressed,
}) => {
  const printProject = () => {
    setIsPrintPressed(true)
    window.print()
  }
  return (
    <Button
      type="secondary"
      text={t('general.print')}
      icon={<Icon type="print" />}
      onClick={printProject}
      textAlways={true}
    />
  )
}

PrintButton.propTypes = {
  t: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
}

export default withNamespaces('translations')(PrintButton)
